import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HotelService } from '../services/hotel.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  msg: any;
  username: any;
  password: any;
  constructor(private router: Router, private hotelService: HotelService) { }

  ngOnInit() {
    this.hotelService.logout();
  }
  public log:any;
  login(e) {
    e.preventDefault();
    let user = e.target.elements[0].value;
    let pwd = e.target.elements[1].value;

    if (user == "admin" && pwd == "admin@123") {
      this.msg = "Login Successful. Please wait...";
      localStorage.setItem('currentUser', JSON.stringify(user));
      setTimeout(() => {
        this.router.navigate(['receipthotel']);
      }, 2000);
    }
    else {
      this.msg = "Login failed. username or password is wrong...";
    }

  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/login/login.component.ts